import React, { useContext, useRef, useEffect } from "react";
import StoreContext from "@/context/root-store";
import { observer } from "mobx-react";
import TiTroviIn from "@/widget/TiTroviIn";
import LogoParita from "../../../img/logoheaderpage.png";
var Organismi = observer(function (props) {
  var rootStore = useContext(StoreContext).rootStore;
  var isMounted = useRef(false);
  var BREADCRUMB_TITOLO = "Organismi di certificazione";
  var BREADCRUMB_CHILDREN = [{
    to: process.env.CONTEXT_PATH + "/home",
    label: "Home"
  }];
  var breadcrumb = /*#__PURE__*/React.createElement(TiTroviIn, {
    children: BREADCRUMB_CHILDREN,
    title: BREADCRUMB_TITOLO
  });
  var $ = require('jquery');
  useEffect(function () {
    document.title = "Certificazione della parità di genere - Organismi certificatori";
    $("#ita.list-inline-item").addClass("active");
    $("#eng.list-inline-item").removeClass("active");
  });
  return rootStore.uiStore.numberCallback === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bgColorGrayLight"
  }, /*#__PURE__*/React.createElement("div", {
    className: "postizioneLogoHeader"
  }, /*#__PURE__*/React.createElement("img", {
    src: LogoParita,
    alt: "",
    className: "img-fluid dimImage",
    width: "500"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-0"
  }, breadcrumb, /*#__PURE__*/React.createElement("div", {
    className: "row altezzaMin"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("h2", null, "Elenco organismi di certificazione accreditati"), /*#__PURE__*/React.createElement("p", null, "Al rilascio della certificazione della parit\xE0 di genere alle imprese, in conformit\xE0 alla UNI/PdR 125:2022, provvedono i soli organismi di certificazione accreditati ai sensi del regolamento CE 765/2008: in Italia tali organismi sono solo quelli accreditati da Accredia, l\u2019Ente italiano di accreditamento."), /*#__PURE__*/React.createElement("p", null, " ", /*#__PURE__*/React.createElement("strong", null, "Attraverso questo ", /*#__PURE__*/React.createElement("a", {
    href: "https://piattaforma.pariopportunita.gov.it/pargen-odc-fe/",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"), "link"), " \xE8 possibile accedere all'area riservata dedicata agli organismi di certificazione accreditati. ")))))), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("p", null, "Di seguito la lista in aggiornamento degli organismi di certificazione accreditati:"), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid mt-5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("b", null, "Tabella organismi di certificazione"))), /*#__PURE__*/React.createElement("div", {
    className: "table-responsive-sm "
  }, /*#__PURE__*/React.createElement("table", {
    className: "table table-bordered table-sm",
    style: {
      overflowWrap: "anywhere"
    }
  }, /*#__PURE__*/React.createElement("caption", {
    className: "sr-only"
  }, "Tabella organismi di certificazione"), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    className: "text-sm-center w-custom1"
  }, /*#__PURE__*/React.createElement("b", null, "N.")), /*#__PURE__*/React.createElement("th", {
    className: "text-sm-center w-custom2"
  }, /*#__PURE__*/React.createElement("b", null, "Nominativo organismo di certificazione")), /*#__PURE__*/React.createElement("th", {
    className: "text-center w-custom3"
  }, /*#__PURE__*/React.createElement("b", null, "Sito web")), /*#__PURE__*/React.createElement("th", {
    className: "text-center w-custom5"
  }, /*#__PURE__*/React.createElement("b", null, "Stato dell'iscrizione all'Elenco per l'erogazione dei contributi alle PMI")), /*#__PURE__*/React.createElement("th", {
    className: "text-center w-custom4"
  }, /*#__PURE__*/React.createElement("b", null, "Data accreditamento ambito UNI/PdR 125:2022"))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "01"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "BUREAU VERITAS CERTIFICATION HOLDING SAS ITALY BRANCH"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, " ", /*#__PURE__*/React.createElement("a", {
    href: "https://www.bureauveritas.it/",
    target: "_blank"
  }, "www.bureauveritas.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 13.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "09.04.2025")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "02"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "DNV Business Assurance Italy S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.dnv.it/",
    target: "_blank"
  }, "www.dnv.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 13.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "30.06.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "03"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "RINA Services S.p.A."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.rina.org/it/",
    target: "_blank"
  }, "www.rina.org ", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 13.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "30.06.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "04"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "UNITER S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://uniter-italia.com/",
    target: "_blank"
  }, "www.uniter-italia.com ", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 13.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "21.07.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "05"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "SUSTAINY S.r.l. a Socio Unico"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.sustainy.it/",
    target: "_blank"
  }, "www.sustainy.it ", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 04.05.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "19.12.2024")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "06"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "GCERTI ITALY ASSESSMENT & CERTIFICATION S.R.L. SOCIET\xC0 BENEFIT IN SIGLA GCERTI ITALY S.R.L. S.B."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.gcerti.it/",
    target: "_blank"
  }, "www.imq.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Sospeso a seguito di un provvedimento sanzionatorio di ACCREDIA della durata massima di 6 mesi"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "Sospeso a seguito di un provvedimento sanzionatorio di ACCREDIA della durata massima di 6 mesi")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "07"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "IMQ S.P.A."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.imq.it/it",
    target: "_blank"
  }, "www.imq.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 13.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "26.10.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "08"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "KIWA CERMET ITALIA S.P.A."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.kiwa.com/it/it/",
    target: "_blank"
  }, "www.kiwa.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 30.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "26.10.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "09"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "QUASER CERTIFICAZIONI S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://quasercert.com/",
    target: "_blank"
  }, "www.quasercert.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 13.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "26.10.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "10"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "Q-AID ASSESSMENT & CERTIFICATION S.r.l. UNIPERSONALE"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.q-aid.it/",
    target: "_blank"
  }, "www.q-aid.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 30.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "28.02.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "11"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "SGS ICS Italia S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.sgs.com/en",
    target: "_blank"
  }, "www.sgs.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 04.05.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "01.01.2025")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "12"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "CERTIFICA S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.certificasistemi.com/",
    target: "_blank"
  }, "www.certificasistemi.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 13.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "21.11.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "13"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "CERTIQUALITY S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.certiquality.it/",
    target: "_blank"
  }, "www.certiquality.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 30.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "21.11.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "14"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "DASA R\xC4GISTER S.p.A."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.dasa-raegister.com/",
    target: "_blank"
  }, "www.dasa-raegister.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 13.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "21.11.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "15"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "T\xDCV Italia S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.tuvsud.com/it-it",
    target: "_blank"
  }, "www.tuvsud.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 04.05.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "21.11.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "16"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "CSQA CERTIFICAZIONI S.R.L."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.csqa.it/it-it",
    target: "_blank"
  }, "www.csqa.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 13.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "21.12.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "17"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ERGO SOCIET\xC0 DI CERTIFICAZIONE E VALIDAZIONE S.R.L."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.ergo.bz",
    target: "_blank"
  }, "www.ergo.bz", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 30.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "21.12.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "18"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "SMC SOCIET\xC0 MEDITERRANEA CERTIFICAZIONI S.R.L."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.smc-certificazioni.it",
    target: "_blank"
  }, "www.smc-certificazioni.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 30.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "21.12.2022")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "19"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "AFNOR ITALIA S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "http://www.afnor.it",
    target: "_blank"
  }, "www.afnor.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 13.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "19.01.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "20"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "DEKRA Testing and Certification S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.dekra.it/it/dekra-testing-certification/",
    target: "_blank"
  }, "www.dekra.it/it/dekra-testing-certification", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 30.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "19.01.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "21"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "SQS Italia S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.sqsitalia.it/",
    target: "_blank"
  }, "www.sqsitalia.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 13.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "04.04.2024")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "22"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ACM CERT S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://acmcert.it/",
    target: "_blank"
  }, "www.acmcert.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 12.06.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "22.02.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "23"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "SI CERT ITALY S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://sicert.net/",
    target: "_blank"
  }, "www.sicertitaly.eu", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 30.03.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "22.02.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "24"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "BSI GROUP ITALIA S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.bsigroup.com/",
    target: "_blank"
  }, "www.bsigroup.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 15.11.2024"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "24.03.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "25"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "CERTITALIA S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.certitalia.it/",
    target: "_blank"
  }, "www.certitalia.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 04.05.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "24.03.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "26"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ECO EUROPEAN CERTIFYING ORGANIZATION S.P.A."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.eco-cert.it/",
    target: "_blank"
  }, "www.eco-cert.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 26.05.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "24.03.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "27"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ICIM S.p.A."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://icimgroup.com/icim/",
    target: "_blank"
  }, "www.icimgroup.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 04.05.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "24.03.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "28"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ICMQ S.P.A."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.icmq.it/",
    target: "_blank"
  }, "www.icmq.org", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 04.07.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "20.04.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "29"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "DIMITTO ITALIA S.R.L. SOCIET\xC0 BENEFIT"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.dimitto.com/",
    target: "_blank"
  }, "www.dimitto.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 12.06.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "20.04.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "30"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "INTERTEK ITALIA S.p.A."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.intertek.it/",
    target: "_blank"
  }, "www.intertek.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 12.06.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "20.04.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "31"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ITALY BUREAU OF CERTIFICATION S.R.L."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.ibvsrl.it/",
    target: "_blank"
  }, "www.ibv.srl", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 26.05.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "20.04.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "32"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "T\xDCV NORD ITALIA S.R.L."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.tuv-nord.com/it/it/",
    target: "_blank"
  }, "www.tuev-nord.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 12.06.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "20.04.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "33"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "SA CERTIFICATION S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://sa-certification.it/",
    target: "_blank"
  }, "www.sa-certification.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 04.07.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "25.05.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "34"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "T\xDCV Rheinland Italia S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.tuv.com/italy/it/",
    target: "_blank"
  }, "www.tuv.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 04.07.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "25.05.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "35"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "APAVE CERTIFICATION Italia S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://italy.apave.com/it-IT",
    target: "_blank"
  }, "www.apave-certification.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 24.07.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "15.06.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "36"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "QUALITY Italia S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.qualityitalia.it/",
    target: "_blank"
  }, "www.qualityitalia.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 19.09.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "15.06.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "37"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ICDQ S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://icdq.it/",
    target: "_blank"
  }, "www.icdq.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 19.09.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "24.07.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "38"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "AENOR ITALIA S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.aenoritalia.com/",
    target: "_blank"
  }, "www.aenoritalia.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 10.11.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "25.09.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "39"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ANCCP CERTIFICATION AGENCY S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.anccp.it/",
    target: "_blank"
  }, "www.anccp.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 21.11.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "25.09.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "40"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "C&M S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.cmcert.it/",
    target: "_blank"
  }, "www.cmcert.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 21.11.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "25.09.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "41"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "CERSIST S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.cersist.it/",
    target: "_blank"
  }, "www.cersist.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 10.11.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "25.09.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "42"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "CVI S.r.l.s."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.cvi-italia.com/",
    target: "_blank"
  }, "www.cvi-italia.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 08.02.2024"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "25.09.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "43"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "Perry Johnson Registrars Inc."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.pjr.com/",
    target: "_blank"
  }, "www.pjr.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 29.11.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "25.09.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "44"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ANCIS S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.ancis.it/",
    target: "_blank"
  }, "www.ancis.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 29.11.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "08.11.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "45"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "AUTENTICERT S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://autenticert.it/",
    target: "_blank"
  }, "https://autenticert.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 29.11.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "08.11.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "46"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "MSCERT- MANAGEMENT SYSTEMS CERT S.R.L."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.mscert.it/",
    target: "_blank"
  }, "www.mscert.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 29.11.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "08.11.2023")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "47"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ASACERT ASSESSMENT AND CERTIFICATION S.P.A. SOCIETA' BENEFIT - ASACERT S.P.A. SOCIETA' BENEFIT"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://asacert.com/it/",
    target: "_blank"
  }, "www.asacert.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 28.12.2023"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "13.09.2024")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "48"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "GSC GLOBAL SYSTEM CERTIFICATION S.R.L."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.gsc-certificazione.it/",
    target: "_blank"
  }, "www.gsc-certificazione.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal  20.03.2024"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "29.02.2024")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "49"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ACSQ S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.acsq.it/",
    target: "_blank"
  }, "www.acsq.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 16.05.2024"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "04.04.2024")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "50"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "TUV THURINGEN Italia S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://tuv-thuringen.it/",
    target: "_blank"
  }, "www.tuv-thuringen.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 09.07.2024"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "04.04.2024")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "51"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "CENTRO CERTIFICAZIONE QUALIT\xC0 \u2013 C.C.Q.  S.R.L."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "http://www.centrocert.it/",
    target: "_blank"
  }, "www.centrocert.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 06.05.2025"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "23.07.2024")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "52"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "PROGETTO COSTRUZIONE QUALIT\xC0 - P.C.Q. S.R.L."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.pcq-srl.it/",
    target: "_blank"
  }, "www.pcq-srl.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 16.09.2024"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "23.07.2024")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "53"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "European Quality Assurance Italia S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://eqaitalia.com/",
    target: "_blank"
  }, "www.eqaitalia.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 30.10.2024"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "30.09.2024")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "54"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "QS CERTIFICAZIONI ITALIA S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://qscert.it/",
    target: "_blank"
  }, "www.qscert.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 07.03.2025"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "30.09.2024")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "55"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ITEC - Istituto Tecnologico Europeo di Certificazione S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.itec-cert.it/",
    target: "_blank"
  }, "www.itec-cert.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "05.11.2024")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "56"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "CISE - CENTRO PER L'INNOVAZIONE E LO SVILUPPO ECONOMICO"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.ciseonweb.it/",
    target: "_blank"
  }, "www.ciseonweb.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 20.03.2025"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "29.01.2025")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "57"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "PLC S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.plcert.com/",
    target: "_blank"
  }, "www.plcert.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "29.01.2025")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "58"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "TUV AUSTRIA ITALIA S.p.A."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://tuvaustriaitalia.com/",
    target: "_blank"
  }, "www.tuvaustriaitalia.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }, "Iscritto dal 13.02.2026"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "09.04.2025")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "59"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "Bureau Veritas Italia S.p.A."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.bureauveritas.it/",
    target: "_blank"
  }, "www.bureauveritas.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "22.07.2025")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "60"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "I.C.M. INSTITUT DE CERTIFICATION MEDITERRANEEN S.A.R.L."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.icmmediterraneen.org/",
    target: "_blank"
  }, "www.icmmediterraneen.com", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "30.09.2025")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "61"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "Istituto Giordano S.p.A."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.giordano.it/",
    target: "_blank"
  }, "www.giordano.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "30.09.2025")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "62"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "IIP S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.giordano.it/",
    target: "_blank"
  }, "www.iip.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "18.11.2025")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "63"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "DI.QU. S.r.l."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.diqu.it",
    target: "_blank"
  }, "www.iip.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "28.01.2026")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "64"), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "ITALCERTIFER S.p.A."), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.italcertifer.com",
    target: "_blank"
  }, "www.iip.it", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "sito: apre una nuova finestra"))), /*#__PURE__*/React.createElement("td", {
    className: "text-center, greenlabel"
  }), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, "28.01.2026")))))))));
});
export default Organismi;